import React from "react";
import { cn } from "../../lib/utils";

const MAP = {
  // activity
  "available": { label: "Available", cls: "bg-grass/15 text-grass border-grass" },
  "almost-full": { label: "Almost Full", cls: "bg-sunny/20 text-sunny-dark border-sunny", },
  "fully-booked": { label: "Fully Booked", cls: "bg-destructive/15 text-destructive border-destructive" },
  "no-booking": { label: "No Booking Required", cls: "bg-sky/25 text-sky-dark border-sky-dark" },
  // payment / ticket
  Paid: { label: "Paid", cls: "bg-grass/15 text-grass border-grass" },
  Pending: { label: "Pending", cls: "bg-sunny/20 text-sunny-dark border-sunny" },
  Cancelled: { label: "Cancelled", cls: "bg-destructive/15 text-destructive border-destructive" },
  Active: { label: "Active", cls: "bg-grass/15 text-grass border-grass" },
  // booking
  Confirmed: { label: "Confirmed", cls: "bg-grass/15 text-grass border-grass" },
  // check-in
  Registered: { label: "Registered", cls: "bg-sky/25 text-sky-dark border-sky-dark" },
  "Checked In": { label: "Checked In", cls: "bg-grass/15 text-grass border-grass" },
  "No Show": { label: "No Show", cls: "bg-slate-200 text-slate-600 border-slate-400" },
};

export function StatusBadge({ status, className }) {
  const cfg = MAP[status] || { label: status, cls: "bg-slate-100 text-slate-600 border-slate-300" };
  return (
    <span
      data-testid={`status-badge-${String(status).toLowerCase().replace(/\s+/g, "-")}`}
      className={cn(
        "inline-flex items-center gap-1.5 font-bold text-xs sm:text-sm px-3 py-1 rounded-full border-2",
        cfg.cls,
        className
      )}
    >
      <span className="w-2 h-2 rounded-full bg-current opacity-70" />
      {cfg.label}
    </span>
  );
}
